import React from 'react'
import { Divider, Text } from 'pcln-design-system'
import SearchItem from './SearchItem'
import { Location } from '../../../server/utils/typeahead-fetch-types'

type RenderRecentSearchesType = {
  getItemProps: () => void
  highlightedIndex: number
  recentSearches: Location[]
  gaTracking: () => void
}

const RenderRecentSearches = ({
  getItemProps,
  highlightedIndex,
  recentSearches,
  gaTracking
}: RenderRecentSearchesType) => {
  return (
    <>
      <Text fontSize={0} p={2} fontWeight="bold">
        Recent Searches
      </Text>
      <Divider my={0} color="border.base" />
      {recentSearches.map((item, index) => {
        return (
          <SearchItem
            key={item.id}
            isItemSelected={index === highlightedIndex}
            index={index}
            item={item}
            getItemProps={getItemProps}
            gaTracking={gaTracking}
          />
        )
      })}
    </>
  )
}

export default RenderRecentSearches
